import React from 'react';
import V1CTAButton from './V1CTAButton';
import './V1PricingFunnel.css';

interface V1PricingFunnelProps {
  theme: 'premium' | 'energetic';
  onCTAClick: () => void;
}

const V1PricingFunnel: React.FC<V1PricingFunnelProps> = ({ theme, onCTAClick }) => {
  const plans = [
    {
      name: 'Zajęcia Grupowe',
      price: '65',
      period: '60 min',
      features: ['3-6 uczniów', 'Online', 'Materiały w cenie', 'Dostęp do platformy'],
      popular: false
    },
    {
      name: 'Zajęcia Indywidualne',
      price: '150',
      period: '60 min',
      features: ['1 na 1', 'Online', 'Spersonalizowany plan', 'Materiały premium', 'Wsparcie 24/7'],
      popular: true
    }
  ];

  return (
    <section className="v1-pricing-funnel v1-section">
      <div className="v1-container">
        <h2 className="v1-section-title v1-animate-in">
          {theme === 'premium' ? 'Wybierz Swój Plan' : '💰 WYBIERZ SWÓJ PLAN'}
        </h2>

        <div className="v1-pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`v1-pricing-card v1-glass ${plan.popular ? 'popular' : ''} v1-animate-in`}
              style={{ animationDelay: `${0.2 + index * 0.1}s` }}
            >
              {plan.popular && <div className="v1-popular-badge">⭐ Najpopularniejsze</div>}

              <h3>{plan.name}</h3>
              <div className="v1-price">
                <span className="v1-price-amount">{plan.price}</span>
                <span className="v1-price-currency">PLN</span>
                <span className="v1-price-period">/ {plan.period}</span>
              </div>

              <ul className="v1-features-list">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>✓ {feature}</li>
                ))}
              </ul>

              <V1CTAButton
                variant="primary"
                size="medium"
                urgency={plan.popular}
                theme={theme}
                onClick={onCTAClick}
              >
                Rezerwuj teraz
              </V1CTAButton>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default V1PricingFunnel;
